import React from 'react'
import { Text } from 'components/ds'

export function SubscriptionDisclaimerText({
  subscriptionPeriod,
}: {
  subscriptionPeriod: 'annual' | 'monthly'
}) {
  return (
    <Text size="1">
      By signing up for the DISCO Services, you are agreeing to the automatic
      renewal of these charges on{' '}
      <span>{subscriptionPeriod === 'annual' ? 'an' : 'a'}</span>{' '}
      <span>
        {subscriptionPeriod} basis from the date of sign up. If you would like
        to cancel these Services, you may do so via the Billing & Subscriptions
        page at anytime prior to your next renewal.
      </span>
    </Text>
  )
}
